import { BpUserManager } from '../BpUserManager';

export const bpUserManager = new BpUserManager();
